import clsx from 'clsx';
import React from 'react';

import Highlight from '../../FeedItems/Highlight';

interface HeaderProps {
  highlight: string;
  title: string;
  titleClassName?: string;
  subTitle: string;
  subTitleClassName?: string;
}

const Header = ({ highlight, title, titleClassName, subTitle, subTitleClassName }: HeaderProps) => {
  return (
    <>
      {highlight && <Highlight highlight={highlight} className="!text-caption-md" />}
      <h1
        className={clsx(
          'my-8 font-suisse-works text-headline-sm text-black print:!text-headline-sm sm:text-headline-xl',
          titleClassName
        )}
      >
        {title}
      </h1>
      {subTitle && (
        <h3
          className={clsx(
            'm-0 font-suisse-neue text-subheadline-sm text-black print:!text-subheadline-sm sm:text-subheadline-lg ',
            subTitleClassName
          )}
        >
          {subTitle}
        </h3>
      )}
    </>
  );
};

export default Header;
